var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('account-page',{attrs:{"title":_vm.$t('Settings')}},_vm._l((_vm.settingsSections),function(section){return _c('settings-section',{key:section.name,attrs:{"title":section.title}},[_c(section.component,{tag:"component"})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }